export default (marital) => {
    switch(marital) {
        case 'married': return 'Casado (a)';
        case 'divorcerd': return 'Divorciado (a)';
        case 'widow': return 'Viúvo (a)';
        case 'not_married': return 'solteiro (a)';
        default : return 'Não identificado';
    }
}